const rings = Array.from({ length: 26 }, (_, i) => i + 1);

/** Desktop login left: deep blue → violet (top-left → bottom-right). */
const DESKTOP_LOGIN_BG =
  'linear-gradient(135deg, #2563EB 0%, #4B56E8 38%, #6D28D9 72%, #7C3AED 100%)';

/** Desktop register left: purple → deep blue (top-left → bottom-right). */
const DESKTOP_REGISTER_BG =
  'linear-gradient(135deg, #7C3AED 0%, #6D28D9 32%, #4F46E5 62%, #2563EB 100%)';

/**
 * @param {'default' | 'desktopLogin' | 'desktopRegister'} variant
 *   - default: sky → violet + rings — `/welcome`, mobile login/register headers
 *   - desktopLogin / desktopRegister: desktop-only auth left panels (inline gradient + dot grid)
 */
export const AuthGradientBackground = ({ className = '', variant = 'default', children }) => {
  if (variant === 'desktopLogin' || variant === 'desktopRegister') {
    const bg = variant === 'desktopLogin' ? DESKTOP_LOGIN_BG : DESKTOP_REGISTER_BG;
    return (
      <div
        className={`min-h-full min-w-0 overflow-hidden ${className}`.trim()}
        style={{ background: bg }}
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.32]"
          style={{
            backgroundImage: 'radial-gradient(rgba(255,255,255,0.16) 1px, transparent 1px)',
            backgroundSize: '14px 14px',
          }}
          aria-hidden
        />
        {children}
      </div>
    );
  }

  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-br from-sky-500 via-brand-600 to-violet-700 ${className}`.trim()}
    >
      <div className="pointer-events-none absolute inset-0" aria-hidden>
        <svg
          className="absolute -right-[20%] -top-[25%] h-[min(120vw,520px)] w-[min(120vw,520px)] opacity-[0.13] sm:h-[min(90vw,560px)] sm:w-[min(90vw,560px)]"
          viewBox="0 0 400 400"
          fill="none"
        >
          {rings.map((i) => (
            <circle key={i} cx="400" cy="0" r={i * 15} stroke="white" strokeWidth="0.55" />
          ))}
        </svg>
      </div>
      {children}
    </div>
  );
};
